// Respaldo bilingue del alta y el uso de cupones (modulo "newCourtesy").
//
// POR QUE EXISTE: el modulo se escribio con los avisos en ingles fijo, asi que
// quien tenia la interfaz en español leia "Couldn't save coupon info." en medio
// de una pantalla en español. No hay ninguna clave `LBxxxx`/`ALxxxx` publicada
// para este flujo, de modo que aqui no hay `texts?.CLAVE ||` que anteponer: el
// dia que backend las de de alta, se antepone el esquema como en el resto.

import { normalizeInterfaceLanguage } from "../interfaceLanguage";

const couponMessages = {
  es: {
    copiedToClipboard: "Copiado al portapapeles",
    copyFailed: "No se pudo copiar. Inténtalo de nuevo.",
    loadCategoriesFailed: "No se pudieron cargar las categorías",
    loadDiscountTypesFailed: "No se pudieron cargar los tipos de descuento",
    codeGenerated: "Código generado",
    saveCouponInfoFailed:
      "No se pudo guardar la información del cupón. Inténtalo de nuevo.",
    missingCouponId: "Falta el ID del cupón. Completa primero el paso 1.",
    validitySaved: "Vigencia y disponibilidad guardadas.",
    saveValidityFailed:
      "No se pudo guardar la vigencia y la disponibilidad. Inténtalo de nuevo.",
    saveTermsFailed: "No se pudieron guardar los términos y el cumplimiento",
    submittedForReview: "Enviado a revisión",
    submitCouponFailed: "Algo salió mal al enviar el cupón.",
  },
  en: {
    copiedToClipboard: "Copied to clipboard",
    copyFailed: "Couldn't copy. Please try again.",
    loadCategoriesFailed: "Couldn't load categories",
    loadDiscountTypesFailed: "Couldn't load discount types",
    codeGenerated: "Code generated",
    saveCouponInfoFailed: "Couldn't save coupon info. Please try again.",
    missingCouponId: "Coupon ID is missing. Please complete Step 1 first.",
    validitySaved: "Validity & availability saved.",
    saveValidityFailed:
      "Couldn't save validity & availability. Please try again.",
    saveTermsFailed: "Couldn't save Terms & Compliance",
    submittedForReview: "Submitted for review",
    submitCouponFailed: "Something went wrong submitting the coupon.",
  },
};

export const getCouponMessages = (language) =>
  couponMessages[normalizeInterfaceLanguage(language)];
